//import './carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue-carousel'

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
	name		: 'come-in-popup',
	data() {
		return {
			show            : false,
			disable         : false,
			closeBtn     	: false,
			date            : "",
			dateFormated    : "",
			price           : "",
			str				: ""
		}
	},
	components	: {
		Carousel,
		Slide,
		Pagination,
		Navigation,
	},
	computed	: {
		...mapGetters({
			user                : 'user/user',
			loadingUser         : 'user/loadingUser',
			userTariff          : `user/userTariff`,
			userTariffLoading   : `user/userTariffLoading`,
			cardsList           : "userPayments/cardsList",
			openNotification    : "userPayments/openNotification",
			defaultLocale       : "setting/defaultLocale",
			config              : "setting/config"
		}),
		currentRoute() {
			return this.$route.fullPath;
		}
	},
	created() {
		//console.log('come-in-popup created');
		
		this.show = false;
		
		this.changeOpenNotification(this.show);
		
		this.str = this.$t('addCardSlide4Help');
	},
	mounted() {
		//console.log('come-in-popup mounted');
		
		this.show = false;
		
		this.changeOpenNotification(this.show);
		
		this.loadData();
		
		//this.show = true;
		
		//this.changeOpenNotification(this.show);
	},
	watch: {
		user: {
			handler() {
				//console.log('user3:');
				//console.log(this.user);
				
				this.show = false;
				
				this.changeOpenNotification(this.show);
				
				if(this.user != null){
					this.loadData();
				}
			},
			deep: true
		},
		$route(to, from) {
			//console.log('Маршрут изменился:', from.fullPath, '→', to.fullPath);
			
			//var nameFrom	= from.name.split('-')[0];
			var nameTo		= to.name.split('-')[0];
			
			if(nameTo != 'profile' && this.user != null){
				//console.log('ok');
				
				this.loadData();
			}
		}
	},
	methods		: {
		...mapActions({
			setNewPaymentsMethod    : "userPayments/SET_NEW_PAYMENTS_METHOD",
			fetchUser               : "user/GET_USER_DATA",
			fetchUserTariff         : "user/GET_USER_TARIFF",
			fetchCardsList          : "userPayments/GET_CARDS_LIST"
		}),
		...mapMutations({
			changeOpenNotification  : "userPayments/CHANGE_OPEN_NOTIFICATION"
		}),
		nextSlide(){
			this.$refs.cardsCarousel.goToLastSlide();
		},
		async addCard(){
			//console.log("addCard");
			
			if(this.disable){
				return false;
			}
			
			this.disable = true;
			
			try {
				const response = await this.setNewPaymentsMethod({
					country: "",
					number: "",
					expireDate: "",
					month: "",
					year: "",
					cvv: "",
					is_default: true,
				});
				
				if (response) {
					window.location = response.data.url;
				}else{
					this.disable = false;
				}
			} catch (error) {
				console.error("error", error);

				console.log("***", error.response.data);

				if (error.response.status === 400) {
					this.$toasted.error(error.response.data.message);
				}
				
				this.disable = false;
			}
		},
		async loadData(){
			console.log('come-in-popup loadData');
			//return;
			
			var route = this.$route.name.split('-')[0]
			
			if(route == 'profile'){
				return;
			}
			
			var locale = 'en';
			
			if(this.$store.getters.currentLanguage){
				locale = this.$store.getters.currentLanguage.key;
			}
			
			if(this.user == null){
				this.show = false;
				
				this.changeOpenNotification(this.show);
				
				return;
			}
			
			/*
			if(this.user.isTester != true){
				//console.log('is not Tester');
				
				this.show = false;
				
				this.changeOpenNotification(this.show);
				
				return;
			}
			*/
			
			//console.log('is Tester');
			
			if(this.user.isNotRequiredCards === true){
				this.show = false;
				
				this.changeOpenNotification(this.show);
				
				return;
			}
			
			await this.fetchCardsList();
			
			if(this.cardsList.length > 0){
				this.show = false;
				
				this.changeOpenNotification(this.show);
				
				return;
			}
			
			await this.fetchUserTariff();
			
			//console.log('userTariff:');
			//console.log(this.userTariff);
			
			var tariffs = [];
			
			if(this.userTariff.length > 0){
				//var dates = [];
				
				for(let i = 0; i < this.userTariff.length; i++){
					//tariffs.push(this.userTariff[i]);
					
					//console.log('adminDisconnect:');
					//console.log(this.userTariff[i].adminDisconnect);
					
					//console.log('userDisconnect:');
					//console.log(this.userTariff[i].userDisconnect);
					
					if(
						this.userTariff[i].subscriptionActive
					){
						tariffs.push(this.userTariff[i]);
					}
				}
				
				if(tariffs.length > 0){
					//dates.sort();
					
					tariffs.sort((a, b) => {
						if (a.activeTo > b.activeTo){
							return -1;
						}
						
						if (a.activeTo < b.activeTo){
							return 1;
						}
						
						return 0;
					});
					
					let first = tariffs.pop();
					
					//console.log('first:');
					//console.log(first);
					
					let activeTo = first.activeTo;
					let date = first.activeTo.split(' ')[0].split('-').reverse();
					
					this.date   = date.join('.');
					
					if(locale == 'uk'){
						this.dateFormated   = date.join('.');
					}else{
						let dateObj = new Date(first.activeTo);
						
						var options = {
							month   : "long"
						};
						
						let format = dateObj.toLocaleString('en-EN', options);
						
						this.dateFormated   = format+' '+date[0]+', '+date[2];
					}
					
					this.price  = first.tariff.data.price;
					
					//console.log('dateFormated:');
					//console.log(this.dateFormated);
					
					//
					
					this.str = this.str.replace(':date', this.dateFormated);
					this.str = this.str.replace(':price', first.tariff.data.price);
					
					//console.log('str:');
					//console.log(this.str);
					
					
					//
					
					let currentDate = new Date().toISOString();
					
					if(activeTo <= '2026-12-20 23:59:59' && activeTo > currentDate){
						this.closeBtn   = true;
					}
					
					this.show   = true;
				}
			}
			
			//console.log('tariffs:');
			//console.log(this.tariffs);
			
			this.changeOpenNotification(this.show);
		},
		toSubscription(){
			//console.log('toSubscription');
			
			this.close();
			
			this.$router.push({ name: 'profile-subscription' });
		},
		close(){
			this.show = false;
		}
	}
}
